import { PrimaryButton } from '@systemeio/ui'
import React from 'react'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ConnectInfoIntegrationProps {
  isFetching?: boolean
  href?: string
  infoText: string
  buttonTitle?: string
  handleOpenIntegrationLogin: () => void
}

export const ConnectInfoIntegration = ({
  isFetching,
  href,
  infoText,
  buttonTitle,
  handleOpenIntegrationLogin,
}: ConnectInfoIntegrationProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className={'flex flex-col gap-4 lg:gap-8'}>
      <span>
        <TransLoco
          t={t}
          i18nKey={infoText}
          components={{
            a: href ? (
              <a href={href} target="_blank" rel="noreferrer" className={'primary-link'} />
            ) : (
              <></>
            ),
            b: <b />,
          }}
        />
      </span>
      <div className={'flex justify-center'}>
        <PrimaryButton width={'small'} onClick={handleOpenIntegrationLogin} isFetching={isFetching}>
          {buttonTitle ?? t('dashboard.user_settings.integrations_page.connect')}
        </PrimaryButton>
      </div>
    </div>
  )
}
